import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import type { ILegalText } from "~/models/ILegalText";

export function stripParagraphPropertiesForLocalStorage(
  legalTextparagraph: MaybeRef<ILegalTextParagraph>,
  legalText: MaybeRef<ILegalText>
): ILegalTextParagraph {
  const { nodes, ancestors, ...paragraph } = toValue(legalTextparagraph);
  const { legal_text_revisions, legal_text_source, ...legal_text } =
    toValue(legalText);

  return {
    ...paragraph,
    legal_text,
  } as ILegalTextParagraph;
}
